import { GTBookingV2Ticket, GTBookingV2TicketServiceFee } from 'gql/types.generated'

import { isTicketCancelled } from './bookings'
import { isEmpty } from 'lodash'

export const getServiceFeeByTicket = (ticket: GTBookingV2Ticket): GTBookingV2TicketServiceFee | undefined => {
  if (!isEmpty(ticket.serviceFee)) {
    return {
      price: ticket.serviceFee?.price,
      id: ticket.serviceFee?.id
    }
  }
}

export const getServiceFeeAmountByTicket = (ticket: GTBookingV2Ticket): { subtotal: number; vat: number } => {
  if (!isTicketCancelled(ticket)) {
    const serviceFee = getServiceFeeByTicket(ticket)

    if (serviceFee) {
      return {
        subtotal: serviceFee.price,
        vat: 0
      }
    }
  }

  return {
    subtotal: 0,
    vat: 0
  }
}

export const getTotalServiceFeeByTicket = (ticket: GTBookingV2Ticket): number => {
  if (!isTicketCancelled(ticket)) {
    const serviceFee = getServiceFeeByTicket(ticket)
    if (serviceFee) {
      return serviceFee.price
    }
  }

  return 0
}

export const getTotalServiceFeeByTickets = (tickets: GTBookingV2Ticket[]): number => {
  let total = 0

  tickets.forEach((ticket): TSFixMe => {
    total += getTotalServiceFeeByTicket(ticket)
  })

  return total
}
